import { safeJsonParse } from '../../utils/utils';

const GOOGLE_ADS_KEYS = ['gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid'];

/**
 * Parses Elevar `google_ads_click_id` compound strings, e.g.
 * "gclid:ABC|gbraid:XYZ|gad_source:1|gad_campaignid:123"
 */
export function parseGoogleAdsClickId(value) {
  if (value == null || value === '') return {};

  if (typeof value === 'object') {
    return {
      gclid: value.gclid_value || value.gclid || value.value || null,
      gbraid: value.gbraid ?? null,
      wbraid: value.wbraid ?? null,
      gad_source: value.gad_source ?? null,
      gad_campaignid:
        value.gad_campaignid ?? value.gad_campaign_id ?? value.google_ads_campaign_id ?? null,
    };
  }

  if (typeof value === 'string' && value.trim().startsWith('{')) {
    const parsed = safeJsonParse(value, null);
    if (parsed && typeof parsed === 'object') {
      return parseGoogleAdsClickId(parsed);
    }
  }

  const s = String(value).trim();

  if (s.includes('|') || /^[a-z_]+:/i.test(s)) {
    const result = {};
    for (const part of s.split('|')) {
      const colonIdx = part.indexOf(':');
      if (colonIdx === -1) continue;
      const key = part.slice(0, colonIdx).trim().toLowerCase();
      const val = part.slice(colonIdx + 1).trim();
      if (GOOGLE_ADS_KEYS.includes(key) && val) {
        result[key] = val;
      }
    }
    if (Object.keys(result).length) return result;
  }

  const withoutPrefix = s.replace(/^gclid:/i, '');

  if (withoutPrefix.includes('gclid=')) {
    const qs = withoutPrefix.includes('?') ? withoutPrefix.split('?').pop() : withoutPrefix;
    try {
      const gclid = new URLSearchParams(qs).get('gclid');
      if (gclid) return { gclid };
    } catch {
      // ignore
    }
  }

  if (/[&\s|]/.test(withoutPrefix)) return {};

  return withoutPrefix ? { gclid: withoutPrefix } : {};
}

export function extractGclid(value) {
  return parseGoogleAdsClickId(value).gclid || null;
}

/**
 * Resolves Google Ads ids from Elevar params + localStorage fallbacks.
 */
export function resolveGoogleAdsIds(elevarParamsObj = {}, storage = {}) {
  const fromCompound = parseGoogleAdsClickId(elevarParamsObj.google_ads_click_id);

  const gclid =
    elevarParamsObj.gclid ||
    elevarParamsObj.gclid_value ||
    fromCompound.gclid ||
    extractGclid(storage.gclid_value) ||
    extractGclid(storage.gclid) ||
    null;

  return {
    gclid,
    gbraid: elevarParamsObj.gbraid || fromCompound.gbraid || null,
    wbraid: elevarParamsObj.wbraid || fromCompound.wbraid || null,
    gad_source: elevarParamsObj.gad_source || fromCompound.gad_source || null,
    gad_campaignid:
      elevarParamsObj.gad_campaignid ??
      elevarParamsObj.gad_campaign_id ??
      elevarParamsObj.google_ads_campaign_id ??
      fromCompound.gad_campaignid ??
      null,
  };
}
